<template>
  <div>
    <h3 class="py-3">{{$t('admin.alerts.email.editor.preview')}}</h3>
    <div class="email-preview" v-html="computedEmail"></div>
  </div>
</template>

<script>
  export default {
    name: 'email-previewer',
    props: {
      emailMessage: {},
      sliderValues: {
        type: Array,
        required: true
      },
      days: {
        required: true
      },
      replacementWords: {
        required: true
      }
    },
    data () {
      return {}
    },
    computed: {
      computedEmail () {
        return this.emailMessage.replace(/{(.*?)}/g, this.getReplacementWord)
      }
    },
    methods: {
      getReplacementWord (expression) {
        return this.replacementWords[expression.substring(1, expression.length - 1)] || `*${this.$t('admin.alerts.email.wrong_sub')}*`
      }
    }
  }
</script>

<style scoped>
  .email-preview {
    min-height: 10rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/alert/EmailPreviewer.vue